import { render, staticRenderFns } from "./SecurityConfiguration.vue?vue&type=template&id=10373d75&scoped=true&"
import script from "./SecurityConfiguration.vue?vue&type=script&lang=ts&"
export * from "./SecurityConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10373d75",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VDivider,VForm,VRow,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10373d75')) {
      api.createRecord('10373d75', component.options)
    } else {
      api.reload('10373d75', component.options)
    }
    module.hot.accept("./SecurityConfiguration.vue?vue&type=template&id=10373d75&scoped=true&", function () {
      api.rerender('10373d75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/policies/SecurityConfiguration.vue"
export default component.exports